import React from 'react'
import { SanityImageText } from '../../../../../types/generated/graphql-types'
import { mapSanityImageTextToImageTextProps } from '../../../../mapping/ImageTextMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { ImageText } from '../../../blocks/ImageText'
import { Grid } from '../../../Grid'
import { Section } from '../../../Section'

export const ImageTextSerializer = ({
  id,
  isBackgroundImage,
  ...props
}: SanityImageText & BlockWithId) => (
  <Section id={id}>
    {isBackgroundImage ? (
      <ImageText {...mapSanityImageTextToImageTextProps(props)} />
    ) : (
      <Grid>
        <div className="col-span-full">
          <ImageText {...mapSanityImageTextToImageTextProps(props)} />
        </div>
      </Grid>
    )}
  </Section>
)
